export { default } from './BancoDoAuto25Stack';
